module.exports = __webpack_public_path__ + "static/media/js.15a4866e.png";